

































import Vue from 'vue'
export default Vue.extend({
  data() {
    return {
      appid: '',
      minipath: '',
      linkText: '',
    }
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    placement: {
      type: String,
      default: 'top-start',
    },
    popperClass: {
      type: String,
      default: 'mini-insert-box',
    },
  },
  methods: {
    confirm() {
      if(!this.appid && !this.appid.trim()) {
        this.$Message.warning('appid 不能为空')
        return
      }
      if(!this.minipath && !this.minipath.trim()) {
        this.$Message.warning('小程序路径不能为空')
        return
      }
      if(!this.linkText && !this.linkText.trim()) {
        this.$Message.warning('链接文字内容不能为空')
        return
      }
      this.$emit('confirm', {
        appid: this.appid,
        minipath: this.minipath,
        linkText: this.linkText,
      })
      this.appid = ''
      this.minipath = ''
      this.linkText = ''
    },
  },
})
